/**
 * @generated SignedSource<<b3cf5c1ad39a0f47b0cf2e3aa8996015>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type checkoutUIActions_deliveryOptions$data = {
  readonly " $fragmentSpreads": FragmentRefs<"checkoutTransactionReducer_deliveryOptions">;
  readonly " $fragmentType": "checkoutUIActions_deliveryOptions";
};
export type checkoutUIActions_deliveryOptions$key = {
  readonly " $data"?: checkoutUIActions_deliveryOptions$data;
  readonly " $fragmentSpreads": FragmentRefs<"checkoutUIActions_deliveryOptions">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "checkoutUIActions_deliveryOptions"
};

(node as any).hash = "95080b8221f5718d044390139aa1bf40";

export default node;
